import { filterNonNull } from "@zennya/web-component-library/src/components/SegmentIO";
import axios from "axios";
const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const anonSessionToken = async (device_id) => {
  const { data } = await axios.post(`${API_URL}/api/v1/anonymous/sessions/token`, {
    device_id
  });
  return data;
}


async function anonForwardGeocode(query, latitude, longitude, session_token) {
  var params = {
    query: query,
    latitude,
    longitude,
    session_token,
    source: 'WHITE_LABEL_CLIENT',
    device_type: 'WEB'
  };
  
  const paramStr = new URLSearchParams(params).toString();
  const request = {
    method: "GET",
    cache: "force-cache",
  };
  const result = await fetch(`${`${API_URL}/api/2/geocoding/forward`}?${paramStr}`, request);

  return await result?.json();
  
}
function anonReverseGeocode({ latitude, longitude, session_token }) {
  var params = {
    latitude,
    longitude,
    apiKey: process.env.REACT_APP_HERE_MAPS_API_KEY,
    session_token
  };

  return axios.get(`${API_URL}/api/2/geocoding/reverse`, { params: params })
    .then(response => {
      return response.data;
    })
}

const anonCalculate = async ({
  session_token,
  latitude,
  longitude,
  packages,
  extended_packages,
  extended_package_items,
  serviceCategoryTypeId,
}) => {
  const params = filterNonNull({
    lat: latitude,
    lng: longitude,
    extended_package_items,
    packages,
    extended_packages,
    client_type: 'web',
    type: serviceCategoryTypeId,
    should_check_for_payment: true,
    should_check_for_medical_id: false,
    session_token,
  })
  return (await axios.post(`${API_URL}/api/2/bookings/calculate`, params))?.data;
};

const anonFetchSchedules = async (session_token, params) => {
  let result;

  try {
    result = await axios.post(
      `${API_URL}/api/2/bookings/scheduled/verify`,
      { ...params, session_token }
    );
  } catch (e) {
    console.log("📢[booking.service.js:26]: ", e);
  }

  return result?.data || result?.response?.data;
};


export { anonCalculate, anonFetchSchedules, anonReverseGeocode, anonForwardGeocode, anonSessionToken }